<div class="d-flex flex-column flex-root" [attr.id]="compact ? null : 'kt_app_root'"
     [ngClass]="{'auth-page': !compact, 'auth-page--local': !compact && isLocal(), 'auth-page--testing': !compact && isTesting(), 'auth-page--staging': !compact && isStaging(), 'auth-page--prod': !compact && !isLocal() && !isTesting() && !isStaging()}">

    <!--begin::Authentication - Signup Welcome Message -->
    <div class="d-flex flex-column flex-center flex-column-fluid position-relative auth-content">
        <!--begin::Content-->
        <div class="d-flex flex-column flex-center text-center" [ngClass]="compact ? 'p-4' : 'p-10'">
            <!--begin::Wrapper-->
            <div class="card auth-card position-relative"
                 [class.w-md-650px]="!compact"
                 [class.auth-card--compact]="compact"
                 [ngClass]="{'py-5': !compact, 'auth-card--local': !compact && isLocal(), 'auth-card--testing': !compact && isTesting(), 'auth-card--staging': !compact && isStaging(), 'auth-card--prod': !compact && !isLocal() && !isTesting() && !isStaging()}">
                <span *ngIf="showThemeSwitcher" class="theme-switch" [class.theme-switch--light]="getThemeMode() === 'light'" (click)="switchThemeMode()"
                      role="switch" tabindex="0" aria-label="Dark mode" [attr.aria-checked]="getThemeMode() === 'dark'"
                      (keydown.enter)="switchThemeMode()" (keydown.space)="$event.preventDefault(); switchThemeMode()">
                    <i class="fa fa-fw fa-sun"></i>
                    <span class="theme-switch__track">
                        <span class="theme-switch__thumb"></span>
                    </span>
                    <i class="fa fa-fw fa-moon"></i>
                </span>
                <div class="card-body" [ngClass]="compact ? 'py-5' : 'py-15 py-lg-20'">

                    <!--begin::Logo-->
                    <div class="h-100" [ngClass]="compact ? 'mb-4' : 'mb-7'">
                        <div class="login-logo" [ngClass]="{'login-logo--compact': compact}">
                            <app-hexagon-logo [size]="compact ? 40 : 'lg'"></app-hexagon-logo>
                            <span *ngIf="!compact" class="login-logo-text" [style.color]="getThemeMode() === 'light' ? 'var(--bs-light-inverse)' : '#f2f2f2'">Hexagon</span>
                        </div>
                    </div>
                    <!--end::Logo-->

                    <div class="mb-10 entity-selector" *ngIf="!loggedInUser && showEntities">

                        <ng-container *ngFor="let entity of entities">
                            <a href="https://{{ hostPrefix }}.{{ entity.host }}/"
                               class="btn border border-gray-200 mx-2 my-2 btn-highlight entity-tile {{ entity.host == currentEntityHost ? 'btn-active entity-tile--active' : (getThemeMode() === 'light' ? 'btn-light' : 'btn-outline-dark') }}">
                                <img src="/new_cdb{{ entity.logo }}" alt="" class="entity-logo" [ngClass]="{'logo-invert': getThemeMode() === 'light' && ['TodaysWeb', 'Kiickr'].includes(entity.name)}">
                                <br class="entity-tile__break">
                                <span class="entity-tile__label" [class]="entity.host == currentEntityHost ? 'text-white' : ''">{{ entity.name }}</span>
                            </a>
                        </ng-container>

                    </div>

                    <div *ngIf="message && !loggedInUser" class="text-muted fs-6" [ngClass]="compact ? 'my-4' : 'mb-6'">{{ message }}</div>

                    <div class="row justify-content-around mb-0 sign-in-row">
                        <div class="col-auto">
                            <ng-container *ngIf="!loggedInUser">
                                <asl-google-signin-button
                                        type="standard"
                                        size="large"
                                        [width]="isMobile ? '260' : ''"
                                        shape="pill"
                                        [theme]="getThemeMode() === 'light' ? 'filled_blue' : 'filled_blue'"
                                        logo_alignment="left"></asl-google-signin-button>
                            </ng-container>
                            <ng-container *ngIf="loggedInUser">
                                <div class="d-flex flex-column align-items-center gap-3 signing-in-box">
                                    <div class="signing-in-avatar-wrapper">
                                        <app-admin-avatar [isAdmin]="loggedInUserIsAdmin" size="lg" [autoLoadingCircle]="false">
                                            <!-- Loading circle until the photo is known and loaded; initials only when there's no photo -->
                                            <div *ngIf="profilePicPending" class="signing-in-avatar admin-avatar-loading"></div>
                                            <div *ngIf="!profilePicPending" class="signing-in-avatar signing-in-avatar-initials user-avatar-initials">
                                                {{ getUserInitials(loggedInUser.firstName + ' ' + loggedInUser.lastName) }}
                                            </div>
                                            <img *ngIf="profilePicUrl"
                                                 [src]="profilePicUrl"
                                                 class="signing-in-avatar signing-in-avatar-photo avatar-photo admin-avatar-fade-in"
                                                 [class.loaded]="profilePicLoaded"
                                                 alt="profile picture"
                                                 (load)="profilePicLoaded = true"
                                                 (error)="profilePicUrl = null">
                                        </app-admin-avatar>
                                    </div>
                                    <div class="fw-semibold fs-5">{{ loggedInUser.name }}</div>
                                    <div class="text-muted fs-7">Signing in...</div>
                                    <div *ngIf="nextPage" class="text-muted fs-7 signing-in-next" [title]="nextPage.path">Taking you back to <strong>{{ nextPage.label }}</strong></div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                </div>
            </div>
            <!--end::Wrapper-->
        </div>
        <!--end::Content-->
    </div>
    <!--end::Authentication - Signup Welcome Message-->
</div>
